module.exports = __webpack_public_path__ + "static/HelveticaNeueLTPro-BdCn-ce737e87e04a52e8e8c0fba5a1a12c69.woff";